// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"231":"f08b37ff","265":"1ef25136","270":"f0bed883"}[chunkId] + ".chunk.js";
};